import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  type CarrierLogisticsCredType,
  carrierLogistics,
} from '../standards.js'

export type mtjgCredType = CarrierLogisticsCredType
export const mtjgDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const mtjg: CarrierDef<mtjgCredType> = {
  name: 'Moran Transportation Corporation',
  scac: 'mtjg',
  ltlServices: [{ id: 'standard', name: 'Standard' }],
  ...carrierLogistics,
  engineLayers: ['documents', 'rating', 'pickup', 'tracking', 'profinder'],
  documentTypes: mtjgDocumentTypes,
}
